export const SEARCHING_TASKS_VIEW_TYPES = {
  LIST: 'list',
  GRID: 'grid',
};
